import { useCallback, useEffect, useState } from "react";

/** Con dati non salvati (`attivo`): un clic su un collegamento del portale non parte, e `verso` dice dove portava, per la
 *  domanda «Uscire senza salvare?»; chiudere o ricaricare la scheda apre l'avviso del browser (il testo lo decide il
 *  browser). Il tasto «Indietro» non si ferma: servirebbe il router con i dati (createBrowserRouter), che il portale non
 *  usa. Il clic si prende in cattura sul documento, prima che lo veda il `Link` di React Router. */
export function useAvvisoUscita(attivo: boolean) {
  const [verso, setVerso] = useState<string | null>(null);

  useEffect(() => {
    if (!attivo) return;
    const suClic = (e: MouseEvent) => {
      if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;  // scheda nuova: qui non si perde niente
      const a = e.target instanceof Element ? e.target.closest<HTMLAnchorElement>("a[href]") : null;
      if (!a || (a.target && a.target !== "_self") || a.hasAttribute("download")) return;
      const url = new URL(a.href, window.location.href);
      if (url.origin !== window.location.origin) return;
      const dove = url.pathname + url.search + url.hash;
      if (dove === window.location.pathname + window.location.search + window.location.hash) return;
      e.preventDefault();
      e.stopPropagation();
      setVerso(dove);
    };
    const suUscita = (e: BeforeUnloadEvent) => { e.preventDefault(); e.returnValue = ""; };
    document.addEventListener("click", suClic, true);
    window.addEventListener("beforeunload", suUscita);
    return () => {
      document.removeEventListener("click", suClic, true);
      window.removeEventListener("beforeunload", suUscita);
    };
  }, [attivo]);

  const chiudi = useCallback(() => setVerso(null), []);
  return { verso, chiudi };
}
